import { doFetch } from 'common/baseFetch';
import useSWR, { Fetcher } from 'swr';
import { SunlightResponse } from 'types/sunlightTimes';
import { sunlightFetchPath } from 'utils/urls/tideCharts';

const useFetchSunlight = (spotId: string, startDate?: string) => {
  const {
    data,
    error,
    isLoading: loading,
  } = useSWR(sunlightFetchPath(spotId, startDate), doFetch as Fetcher<SunlightResponse>, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    errorRetryCount: 0,
  });

  return {
    data,
    loading,
    error,
  };
};

export default useFetchSunlight;
